"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHomeBannerApiClient = void 0;
const shared_logger_1 = require("@aladin/shared-logger");
const shared_common_sdk_1 = require("@aladin/shared-common-sdk");
function createHomeBannerApiClient(options) {
    const logger = options.logger ?? shared_logger_1.NOOP_LOGGER;
    const client = (0, shared_common_sdk_1.createAxiosClient)(options.homeBannerApiHost, {
        accessTokenSource: options.accessTokenSource,
    });
    async function findByPartnerId(partnerId) {
        try {
            const response = await client.get(`/v1/partners/${partnerId}/home-banner`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function createOrUpdateHomeBanner(partnerId, homeBanner) {
        try {
            const response = await client.post(`/v1/partners/${partnerId}/home-banner`, homeBanner);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    return {
        findByPartnerId,
        createOrUpdateHomeBanner,
    };
}
exports.createHomeBannerApiClient = createHomeBannerApiClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaG9tZS1iYW5uZXIuY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvbWUtYmFubmVyL2hvbWUtYmFubmVyLmNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx5REFBMkQ7QUFDM0QsaUVBQTBFO0FBNEIxRSxTQUFnQix5QkFBeUIsQ0FBQyxPQUFtQztJQUMzRSxNQUFNLE1BQU0sR0FBRyxPQUFPLENBQUMsTUFBTSxJQUFJLDJCQUFXLENBQUE7SUFFNUMsTUFBTSxNQUFNLEdBQUcsSUFBQSxxQ0FBaUIsRUFBQyxPQUFPLENBQUMsaUJBQWlCLEVBQUU7UUFDMUQsaUJBQWlCLEVBQUUsT0FBTyxDQUFDLGlCQUFpQjtLQUM3QyxDQUFDLENBQUE7SUFFRixLQUFLLFVBQVUsZUFBZSxDQUFDLFNBQWlCO1FBQzlDLElBQUk7WUFDRixNQUFNLFFBQVEsR0FBRyxNQUFNLE1BQU0sQ0FBQyxHQUFHLENBQWdCLGdCQUFnQixTQUFTLGNBQWMsQ0FBQyxDQUFBO1lBQ3pGLE9BQU8sUUFBUSxDQUFDLElBQUksQ0FBQTtTQUNyQjtRQUFDLE9BQU8sR0FBRyxFQUFFO1lBQ1osSUFBSSxHQUFHLFlBQVksS0FBSztnQkFBRSxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksRUFBRSxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUE7WUFDdkQsSUFBQSwrQkFBVyxFQUFDLEdBQUcsQ0FBQyxDQUFBO1NBQ2pCO0lBQ0gsQ0FBQztJQUVELEtBQUssVUFBVSx3QkFBd0IsQ0FBQyxTQUFpQixFQUFFLFVBQXlCO1FBQ2xGLElBQUk7WUFDRixNQUFNLFFBQVEsR0FBRyxNQUFNLE1BQU0sQ0FBQyxJQUFJLENBQWdCLGdCQUFnQixTQUFTLGNBQWMsRUFBRSxVQUFVLENBQUMsQ0FBQTtZQUN0RyxPQUFPLFFBQVEsQ0FBQyxJQUFJLENBQUE7U0FDckI7UUFBQyxPQUFPLEdBQUcsRUFBRTtZQUNaLElBQUksR0FBRyxZQUFZLEtBQUs7Z0JBQUUsTUFBTSxDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFBO1lBQ3ZELElBQUEsK0JBQVcsRUFBQyxHQUFHLENBQUMsQ0FBQTtTQUNqQjtJQUNILENBQUM7SUFFRCxPQUFPO1FBQ0wsZUFBZTtRQUNmLHdCQUF3QjtLQUN6QixDQUFBO0FBQ0gsQ0FBQztBQS9CRCw4REErQkMifQ==